<template>
    <div class="dropdownmenu unselectable" ref="container" :class="{blue: blue, purple: purple}" v-click-outside="unselect">
        <a class="choice" @click="isExpand = !isExpand">
            <div class="icon">
                <img v-if="icon" :src="icon">
            </div>
            <div class="name small">
                <div>{{find(value)}}</div>
            </div>
            <div class="icon" > 
                <img src="../assets/triangle.png" style="width: 14px">
            </div>
        </a>
        <div class="dropdown" v-show="isExpand"> 
            <a class="choice"  v-for="choice in choices" :key="choice" @click="select(choice)">
                <div class="icon">
                    <img src="../assets/check.png" v-show="value === choice.deviceId">
                </div>
                <div class="name" :class="{big: value !== choice.deviceId, small: value === choice.deviceId}">
                    <div>{{choice.label}}</div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import clickOutside from '@/directives/clickOutside.js';

export default {
    name: 'DropdownMenu',
    emits: ['input'],
    directives: {
        clickOutside
    },
    props:{
        choices: {
            type: Array,
            default: () => { return [{
                deviceId: "1",
                label: "1"
            }, {
                deviceId: "2",
                label: "2"
            }]}
        },
        value:{
            type: String,
            default: "1"
        },
        icon:{
            type: String,
            default: null
        },
        blue: {
            type: Boolean,
            default: false
        },
        purple: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        unselect(event){
            if(this.isExpand) {
                this.isExpand = false;
            }
        },
        select(choice){
            this.$emit('input', choice.deviceId);
            this.isExpand = false
        },
        find(id){
            if (!this.choices) {
                return;
            }
            const obj = this.choices.find(function(obj) {
                return obj.deviceId === id;
            })
            if (obj) {
                return obj.label
            } else {
                return null
            }
        }
    },
    data(){
        return{
            isExpand: false
        }
    }
};
</script>

<style scoped>
.dropdownmenu{
    height: 30px; 
    border-radius: 0; 
    display: flex; align-items: center; 
    width: max-content;
    background: red;
}

.icon{
    width: 30px;
    min-width: 30px; 
    height: 30px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    box-sizing: border-box; 
}

.icon img{
    width: 18px;
}

.expand{
    height: 30px; 
    width: 30px; 
    border-radius: 0; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    box-sizing: border-box;
}
.expand img{
    width: 18px;
    height: auto;
}

.name{
    flex: 1;
    line-height: 26px;
    display: flex;
    align-items: center;
    height: 100%;
    width: 90px;
}

.name div{
    overflow: hidden; 
    white-space: nowrap; 
    text-overflow: ellipsis;
    font-size: 14px;
    flex: 1;
}

.dropdown{
    position: absolute; 
    width: 100%; 
    top: 100%; 
    left: 0; 
    display: flex; 
    justify-content: center;
    flex-direction: column; 
    border-radius: 0; 
    margin-top: 2px;
    gap: 2px;
}

.choice{
    width: 100%;  
    max-width: 100%;
    min-width: 100%;
    height: 100%;
    display: flex; 
    align-items: center;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;
    color: black;
}

.choice:hover{
    background: #ccc;
}

.dropdownmenu.purple .choice{
    background: #F5E9FF;
    color: #8a66c7;
}

.dropdownmenu.purple .choice:hover{
    background: #e6ccfc;
}

.dropdownmenu.purple img{
    filter: invert(45%) sepia(30%) saturate(959%) hue-rotate(221deg) brightness(95%) contrast(87%);
}

.dropdownmenu.blue .choice{
    background: #e8f0fe;
    color: #1967D2
}
.dropdownmenu.blue .choice:hover{
    background: #d2e3fc;
}

.dropdownmenu.blue img{
    filter: invert(22%) sepia(92%) saturate(1713%) hue-rotate(202deg) brightness(110%) contrast(90%);
}
</style>